const getTokens = (user) => user.meta.tokens || {}
const getProfile = (user) => user.meta.profile || {}
const getEmail = (user) => {
  const profile = getProfile(user)
  const email = (profile.emails || [])[0] || {}
  return email.value
}
const getDisplayName = (user) => {
  const profile = getProfile(user)
  return profile.displayName || user.username
}
const getImage = (user) => {
  const profile = getProfile(user)
  const photo = (profile.photos || [])[0] || {}
  return photo.value
}
const safeUser = (user) => {
  if(!user || !user.id) return user
  const safeUser = JSON.parse(JSON.stringify(user))
  delete(safeUser.meta.tokens)
  return safeUser
}

const utils = {
  getTokens,
  getProfile,
  getEmail,
  getDisplayName,
  getImage,
  safeUser,
}

module.exports = utils